import { Button, buttonStyle } from 'components/button/Button';
import { defaultButtonStyle } from 'components/button/DefaultButton';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const LinkButton = styled.a`
    ${buttonStyle}
    ${defaultButtonStyle}

    display: inline-block;
    text-decoration: none;
`;

export const MenuLink = styled(NavLink)<{ $padding?: string }>`
    padding-left: ${({ $padding }) => $padding || '1.5rem'};
    padding-right: ${({ $padding }) => $padding || '1.5rem'};
    display: flex;
    align-items: center;
    height: 100%;

    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: transparent;

    color: var(--icon-action-active);

    &:hover {
        border-bottom-color: var(--nav-border);
        color: var(--icon-action-hover);
    }
`;

export const MenuButton = styled(Button)<{ $active?: boolean }>`
    width: 4.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;

    color: ${(props) =>
        props.$active ? 'var(--icon-action-selected)' : 'var(--icon-action-active)'};

    border-radius: 0;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: ${(props) =>
        props.$active ? 'var(--primary-default)' : 'transparent'};

    &:hover {
        border-bottom-color: ${(props) =>
            props.$active ? 'var(--primary-default)' : 'var(--nav-border)'};
        color: ${(props) =>
            props.$active ? 'var(--icon-action-selected)' : 'var(--icon-action-hover)'};
    }

    &:active {
        border-bottom-color: var(--primary-dark);
        color: var(--icon-action-selected);
    }
`;
